export enum UserRoles {
    admin = 'admin',
    manager = 'manager',
    client = 'client',
    analyst = 'analyst',
    builder = 'builder',
    specialRequester = 'specialRequester',
    connectToAccess = 'connectToAccess',
    /**
     * Enables publishing to third-party services.
     *
     * @see https://digitalstack.atlassian.net/browse/DS-5817
     */
    publisher = 'publisher',
    /**
     * Enables use of the planner
     *
     * @see https://digitalstack.atlassian.net/browse/DS-5816
     */
    planner = 'planner',
    /**
     * A test account
     */
    test = 'test',
    /**
     * The backdoor account only available when testing
     */
    backdoor = 'backdoor',
}
